import React from "react";
import UpgradePage from "../UpgradePage";
import FakePaypalButton from "./PaypalButton";
import FakeStripePaymentElement from "./StripePaymentElement";

export default function (props) {
  return (
    <UpgradePage
      {...props}
      PaypalButton={FakePaypalButton}
      StripePaymentElement={FakeStripePaymentElement}
    />
  );
}
